import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    height: Number,
    editable: Boolean
  }
  static targets = [ "counter" ]

  connect() {
    if (!window.tinymce) {
      console.error("TinyMCE is not loaded");
      return;
    }

    this.initTinymce({
        height: this.heightValue || 300,
        editable: (this.hasEditableValue ? this.editableValue : true)
    });
  }

  disconnect() {
    tinymce.remove();
  }

  initTinymce(options) {
    tinymce.init({
      editable_root: options.editable,
      license_key: 'gpl',
      selector: 'textarea.tinymce',
      branding: false,
      footer: false,
      statusbar: false,
      menubar: false,  // This removes the menu bar
      plugins: 'whatsapp_format emoticons wordcount',  // Include the custom plugin and emoticons plugin
      toolbar: 'bold_whatsapp italic_whatsapp strikethrough_whatsapp monospace_whatsapp | emoticons',
      valid_elements: 'br,*[*]/',
      newline_behavior: 'linebreak',
      text_patterns: [],
      paste_as_text: true,
      paste_block_drop: false,
      smart_paste: false,
      paste_data_images: false,
      entity_encoding: 'raw',
      height: options.height,
      setup: (editor) => {

        // TODO: check how to move this into the tinymcepack.js#whatsapp_format plugin
        function applyFormat(wrapper) {
          if (!editor.hasEditableRoot()) return;

          var selectedText = editor.selection.getContent({format: 'text'});
          if (selectedText) {
            editor.selection.setContent(wrapper + selectedText + wrapper);
          } else {
            editor.insertContent(wrapper + wrapper);
            editor.selection.setCursorLocation(editor.selection.getNode(), 1);
          }
        }

        editor.on('init', () => {
          for(var s in editor.shortcuts.shortcuts){
            // Remove all shortcuts except Redo (89), Undo (90)
            if(!(s == "89,meta" || s == "90,meta")){
               // This completely removes the shortcuts
               delete editor.shortcuts.shortcuts[s];
            }
          }

          editor.addShortcut('Meta+b', 'Bold (WhatsApp style)', () => { applyFormat('*'); });
          editor.addShortcut('Meta+i', 'Italic (WhatsApp style)', () => { applyFormat('_'); });
        });
        editor.on('NodeChange', () => {
          if (!editor.hasEditableRoot()) return;

          editor.save(); // Update the underlying textarea
          this.element.dispatchEvent(new CustomEvent('tinymce:change', { bubbles: true }));

          const wordCount = tinymce.activeEditor.plugins.wordcount;
          this.counterTarget.innerText = wordCount.body.getCharacterCount();
        });
      }
    });
  }
}
